import React from 'react';
import styles from './accountType.module.css';

export default function AccountTypes() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2>Feel Free to Choose</h2>
          <p>Any Account Type You Like!</p>
          <div className={styles.divider}></div>
        </div>

        <div className={styles.accountsGrid}>
          {/* STANDARD ACCOUNT - Updated specs as requested */}
          <div className={styles.accountCard}>
            <div className={styles.cardHeader}>
              <h3>STANDARD</h3>
              <p className={styles.cardSubtitle}>Perfect for beginners and casual traders</p>
            </div>
            <div className={styles.cardContent}>
              <p>Trade major FX pairs with competitive spreads and low commissions. Ideal for new traders learning the markets.</p>
              <div className={styles.features}>
                <div className={styles.feature}>
                  <span className={styles.featureLabel}>Min Deposit:</span>
                  <span className={styles.featureValue}>$250</span>
                </div>
                <div className={styles.feature}>
                  <span className={styles.featureLabel}>Leverage:</span>
                  <span className={styles.featureValue}>Up to 1:200</span>
                </div>
                <div className={styles.feature}>
                  <span className={styles.featureLabel}>Spreads:</span>
                  <span className={styles.featureValue}>2 - 3</span>
                </div>
              </div>
            </div>
            <div className={styles.cardActions}>
              <button className={styles.openButton}>OPEN ACCOUNT</button>
              <button className={styles.learnButton}>LEARN MORE</button>
            </div>
          </div>

          {/* PREMIUM ACCOUNT - Removed "pips" */}
          <div className={styles.accountCard}>
            <div className={styles.cardHeader}>
              <h3>PREMIUM</h3>
              <p className={styles.cardSubtitle}>Advanced features for active traders</p>
            </div>
            <div className={styles.cardContent}>
              <p>Enhanced trading conditions with tighter spreads and priority execution. Perfect for experienced traders.</p>
              <div className={styles.features}>
                <div className={styles.feature}>
                  <span className={styles.featureLabel}>Min Deposit:</span>
                  <span className={styles.featureValue}>$1,000</span>
                </div>
                <div className={styles.feature}>
                  <span className={styles.featureLabel}>Leverage:</span>
                  <span className={styles.featureValue}>Up to 1:400</span>
                </div>
                <div className={styles.feature}>
                  <span className={styles.featureLabel}>Spreads:</span>
                  <span className={styles.featureValue}>1.0 - 2.0</span>
                </div>
              </div>
            </div>
            <div className={styles.cardActions}>
              <button className={styles.openButton}>OPEN ACCOUNT</button>
              <button className={styles.learnButton}>LEARN MORE</button>
            </div>
          </div>

          {/* PRO ACCOUNT - Removed "pips" */}
          <div className={styles.accountCard}>
            <div className={styles.cardHeader}>
              <h3>PRO</h3>
              <p className={styles.cardSubtitle}>Professional trading for serious investors</p>
            </div>
            <div className={styles.cardContent}>
              <p>Institutional-grade execution with raw spreads and dedicated support. Built for professional traders.</p>
              <div className={styles.features}>
                <div className={styles.feature}>
                  <span className={styles.featureLabel}>Min Deposit:</span>
                  <span className={styles.featureValue}>$5,000</span>
                </div>
                <div className={styles.feature}>
                  <span className={styles.featureLabel}>Leverage:</span>
                  <span className={styles.featureValue}>Up to 1:500</span>
                </div>
                <div className={styles.feature}>
                  <span className={styles.featureLabel}>Spreads:</span>
                  <span className={styles.featureValue}>1.5 - 2.5</span>
                </div>
              </div>
            </div>
            <div className={styles.cardActions}>
              <button className={styles.openButton}>OPEN ACCOUNT</button>
              <button className={styles.learnButton}>LEARN MORE</button>
            </div>
          </div>

          {/* VIP ACCOUNT - Removed "pips" */}
          <div className={styles.accountCard}>
            <div className={styles.cardHeader}>
              <h3>VIP</h3>
              <p className={styles.cardSubtitle}>Exclusive benefits for high-volume traders</p>
            </div>
            <div className={styles.cardContent}>
              <p>Premium service with personal account manager, exclusive research, and the best trading conditions available.</p>
              <div className={styles.features}>
                <div className={styles.feature}>
                  <span className={styles.featureLabel}>Min Deposit:</span>
                  <span className={styles.featureValue}>$9,000</span>
                </div>
                <div className={styles.feature}>
                  <span className={styles.featureLabel}>Leverage:</span>
                  <span className={styles.featureValue}>Up to 1:700</span>
                </div>
                <div className={styles.feature}>
                  <span className={styles.featureLabel}>Spreads:</span>
                  <span className={styles.featureValue}>0.02 - 0.05</span>
                </div>
              </div>
            </div>
            <div className={styles.cardActions}>
              <button className={styles.openButton}>OPEN ACCOUNT</button>
              <button className={styles.learnButton}>LEARN MORE</button>
            </div>
          </div>

          {/* GOLD ACCOUNT - Updated as requested */}
          <div className={`${styles.accountCard} ${styles.goldCard}`}>
            <div className={`${styles.cardHeader} ${styles.goldHeader}`}>
              <h3>GOLD</h3>
              <p className={styles.cardSubtitle}>Ultimate premium trading experience</p>
            </div>
            <div className={styles.cardContent}>
              <p>Elite-level trading conditions with institutional access, zero spreads, and dedicated relationship manager. The ultimate trading experience.</p>
              <div className={styles.features}>
                <div className={styles.feature}>
                  <span className={styles.featureLabel}>Min Deposit:</span>
                  <span className={styles.featureValue}>$16,000</span>
                </div>
                <div className={styles.feature}>
                  <span className={styles.featureLabel}>Leverage:</span>
                  <span className={styles.featureValue}>Up to 1:1000</span>
                </div>
                <div className={styles.feature}>
                  <span className={styles.featureLabel}>Spreads:</span>
                  <span className={styles.featureValue}>0.0 - 0.03</span>
                </div>
              </div>
            </div>
            <div className={styles.cardActions}>
              <button className={`${styles.openButton} ${styles.goldButton}`}>OPEN ACCOUNT</button>
              <button className={`${styles.learnButton} ${styles.goldLearnButton}`}>LEARN MORE</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
